module.exports = __webpack_public_path__ + "static/media/ihro-logo.6d794aa2.jpg";